<div class="table-page h-full">
  <div class="heading w-full p-0"><span class="text-2xl">Bonus Events</span></div>
  <mat-tab-group
    class="h-full overflow-hidden"
    [selectedIndex]="selectedTabIndex"
    (selectedTabChange)="selectTab($event)"
  >
    <mat-tab label="Active" class="h-full overflow-hidden">
      <sa-bonus-event-active></sa-bonus-event-active>
    </mat-tab>
    <mat-tab label="Ended" class="h-full overflow-hidden">
      <sa-bonus-event-archived></sa-bonus-event-archived>
    </mat-tab>
  </mat-tab-group>
</div>
